import { createFileRoute } from '@tanstack/react-router';

import {
  loadSimulationHireScreen,
  loadSimulationMessages,
  simulationHireScreen,
} from '@/modules/simulation/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Contratar no caminho do legado (`router.tsx:1078-1084`, só com `ENABLE_NEW_SIMULATION === 1`): a flag e a
// permissão vão no manifesto. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/ccb/contratar/')({
  staticData: { screen: simulationHireScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationHireScreen, 'HireRouteScreen'),
});
